
import * as angular from 'angular';
import { fn } from '@common/utils';
import { INavUrlInfo, TNavUrlAccess } from '@common/navdata';
import {
    IFDRW_Workflow_User_Instances_List, IFDRW_Workflow_Invoice_Ledger, OpenBreakoutInNav
} from '@common/rwf';
import { CompatibilityService } from '@common/services/compatibilityservice';
import { GetRowItem } from '@common/navkendo';

// --> TODO Decouple
import { INavGridImp } from '@common/navkendo/navgrid';

/** Absolute path to the file type (extension) icons */
const FILE_ICON_PATH = "./icons/filetype/";
const FILE_EXT_IMAGE = ["ai", "bmp", "dxf", "dwg", "eps", "g3", "gif", "jp2", "j2k", "jpc", "jpe", "jpg", "jpeg", "svg", "png", "ps", "psd", "tga", "tif", "tiff", "pcc", "pcx", "wmf"];
const FILE_EXT_EXCEL = ["xls", "xlsx"];
const FILE_EXT_POWERPOINT = ["ppt", "pptx"];
const FILE_EXT_WORD = ["doc", "docm", "docx", "dot", "dotm", "dotx", "xps", "odt", "rtf"];

export function GetFileIcon(extension: string) {
    let lcExt = (extension || "").toLowerCase();
    if (!lcExt) {
        return FILE_ICON_PATH + "txt16.png";
    } else if (lcExt === "pdf") {
        return FILE_ICON_PATH + "pdf16.png";
    } else if (FILE_EXT_WORD.indexOf(lcExt) >= 0) {
        return FILE_ICON_PATH + "doc16.png";
    } else if (FILE_EXT_EXCEL.indexOf(lcExt) >= 0) {
        return FILE_ICON_PATH + "xls16.png";
    } else if (FILE_EXT_POWERPOINT.indexOf(lcExt) >= 0) {
        return FILE_ICON_PATH + "ppt16.png";
    } else if (FILE_EXT_IMAGE.indexOf(lcExt) >= 0) {
        return FILE_ICON_PATH + "img16.png";
    } else {
        // Fallback icon
        return FILE_ICON_PATH + "txt16.png";
    }
}

//  Template for Documents Description, making Main Doc Bold
export const TMPL_DocDescriptionMainDocBold = `<strong ng-if="dataItem.Type == 1" class="idms_truncate" title="{{dataItem.Description}}">{{dataItem.Description || 'Hauptdokument'}}</strong>` +
    `<span ng-if='dataItem.Type != 1' class="idms_truncate" title="{{dataItem.Description}}">{{dataItem.Description || 'Zusatzdokument'}}</span>`;

/** Edit nav row item (under mouse pointer) in new browser window */
export function OpenRowItem(this: void, $c: CompatibilityService, rowItemOrEvent, readOnly = false) {
    // Get id from rowitem
    var id = rowItemOrEvent && rowItemOrEvent["ID"];
    // Or get id from event
    if (!id) {
        id = GetRowItem(rowItemOrEvent);
        if (id) {
            id = id["ID"];
        }
    }
    if (id) {
        fn.UISafe($c.resolve("NavUrl").NavUrl.then(url => {
            var extParams;
            var urlToOpen = fn.GetAbsoluteUrlPrefix() + "#/kwfEditForm/" + encodeURIComponent(id);
            if (readOnly) {
                extParams = $.extend(extParams, { readonly: "1" });
            }
            extParams = ExtendNavParameters(url, extParams);

            if (extParams) {
                urlToOpen += "?" + fn.EncodeQueryData(extParams);
            }
            var opendKWfDoc = false;
            var openAction = () => {
                if (opendKWfDoc)
                    return;
                opendKWfDoc = true;
                window.open(<any>urlToOpen, "_blank");
            };
            openAction();
        }));
    }
}

/** Caution: Referenced from html */
export function OpenCurrentBreakout(evt: JQueryEventObject) {
    var rowitem = <IFDRW_Workflow_User_Instances_List | IFDRW_Workflow_Invoice_Ledger><any>GetRowItem(evt),
        $injector = angular.element(document).injector(),
        $c = $injector.get("CompatibilityService");

    if (rowitem) {
        // Open loading context menu
        var jqcm = $("<ul></ul>");
        $(document).add(jqcm);
        var cm = jqcm.kendoContextMenu({
            animation: <kendo.ui.ContextMenuAnimation>false,
            dataSource: [{
                text: "Fachprozess (" + rowitem.CurrentBreakout + ")",
                encoded: false,
                items: [{
                    text: "Im Web-Client öffnen",
                    imageUrl: "/icons/LaunchWebSmall.png"
                }]
            }],
            target: $(evt.target),
            orientation: "horizontal",
            deactivate: closedEvt => {
                // Remove from DOM
                closedEvt.sender.destroy();
                jqcm.remove();
            },
            select: (selectEvt: kendo.ui.ContextMenuSelectEvent) => {
                let clickedItem = $(selectEvt.item).closest(".k-item");
                let hasSubElements = clickedItem.find(".k-item").length > 0;
                if (!hasSubElements) {
                    // Open web client
                    OpenBreakoutInNav($c, rowitem.ID)
                }
            }
        }).data("kendoContextMenu");
        cm.open(evt.pageX - 10, evt.pageY - 10);
    }
}

/** Edit nav row item under mouse pointer, Caution: Used from Templates (html) at the moment */
export function EditWorkflowInstance(context: CompatibilityService | Element, evt: Event | kendo.Observable, readOnly = false) {
    if (context instanceof Element) {
        $c = angular.element(context).injector().get("CompatibilityService");
    } else {
        var $c = context;
    }

    return $c.resolve("Rwf")("RwfUserInteraction").EditWorkflowInstance(context, evt, readOnly);
}

/** Start Navigation to Edit form for Invoice Item item */
export function InvoiceEditItem(this: void, $c: CompatibilityService, rowitem: any, navUrl?: TNavUrlAccess, readOnly = false) {
    return $c.resolve("NavUrl").ResolveUrl(navUrl).then(navUrlInfo => {
        const id = rowitem.get("ID"),
            routing = $c.resolve("Routing"),
            urlToOpen = "/kwfEditForm/" + id,
            source = routing.CurrentUrl;

        // Check if Open in new Window is Desired
        if (routing.IsDlg) {
            if (readOnly)
                var extParams = $.extend(extParams, { readonly: 1 });
            extParams = ExtendNavParameters(navUrlInfo, extParams);

            window.open(fn.GetAbsoluteUrlPrefix() + "#" + urlToOpen + (extParams ? "?" + fn.EncodeQueryData(extParams) : ""), "_blank");
            throw fn.error.UICancel();
        }
        return $c.when(routing.path(urlToOpen).search({
            source: source,
            company: navUrlInfo.Mandant,
            readonly: readOnly ? "1" : "0"
        }));
    });
}

/** Extend Parameters for external Call to Same NAV Context, TODO : navUrl instead of company */
export function ExtendNavParameters(urlInfo: INavUrlInfo, p?: Object & { company?: string }) {
    var currCompany = urlInfo && urlInfo.Mandant;
    if (currCompany && (!p || !p.company))
        p = $.extend(p, { company: currCompany });

    return p;
}

/** Get Values from Selected Rows */
export function GetSelectedRowValues(grid: kendo.ui.Grid, propName?: string) {
    function IsINavGridImp(grid: kendo.ui.Grid): grid is INavGridImp {
        const check: INavGridImp = <any>grid;
        return check && (typeof check.GetSelectedItems === "function");
    }

    if (IsINavGridImp(grid)) {
        const gridSelection = (<INavGridImp>grid).GetSelectedItems();
        var selItems = gridSelection && gridSelection.GetSelectedItems().filter(fn.isSet);
    }
    else
        var selItems = $.makeArray((grid && grid.select().map((idx, el) => grid.dataItem(el)))).filter(fn.isSet);

    return (selItems || []).map(item => propName ? item[propName] : item);
}

export const ExternalFilters = {
  Reset: (search: any) => {
    if (search) {
      Object.getOwnPropertyNames(search).filter(item => item.startsWith("fld") || item.startsWith("op")).forEach(item => {
        delete search[item];
      });
    }
  },
  Resolve: (search) => {
    return search && <kendo.data.DataSourceFilters>{
      filters: Object.getOwnPropertyNames(search)
        .map(item => /^fld(.*)/.exec(item))
        .filter(fn.isSet)
        .map(item => <kendo.data.DataSourceFilterItem>(
          {
            field: item[1],
            value: search[item[0]] || '',
            operator: search["op" + item[1]] || ''
          }))
    };
  }
};
